/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: Explore
 *| (C) Copyright IBM Corp. 2018, 2019
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';

import Badge from 'components/badge/Badge';
import { ToolbarItem } from 'components/toolbar/items';
import StringResources from 'nls/StringResources';

import FilterIcon from '@ba-ui-toolkit/ba-graphics/dist/icons/filter_16.svg';

@observer
class FilterDock extends Component {
	constructor(props) {
		super(props);
	}
	/**
     * renders explore filter dock. It shows in compare card mode
     */
	render() {
		const badge = this._renderBadge();
		return (
			<ToolbarItem
				iconId={FilterIcon.id}
				hidden={!this.props.filterDockModel}
				onPrimaryAction={this._handleFilterDockClick.bind(this)}
				title={StringResources.get('exploreFilterDock_Title')}
			>
				{badge}
			</ ToolbarItem>
		);
	}

	/**
	 * renders a badge if number is defined and not zero
	 */
	_renderBadge(){
		const number = this.props.filterDockModel && this.props.filterDockModel.getFilterCount();
		if(number){
			return (<Badge number={number}/>);
		}
	}

	_handleFilterDockClick(){
		const canvasExtensions = this.props.dashboardApi.getDashboardCoreSvc('.CanvasExtensions');
		if (canvasExtensions) {
			const filterDockExtensionView = canvasExtensions.getExtension('filterDock');
			const filterDockCollapseView = canvasExtensions.getExtension('filterDockCollapseControl');
			// attach the extensions to the dom node for canvasExtensions and expand the filter dock
			const dom = document.getElementsByClassName('canvasExtensionTop');
			if(dom[0]){
				dom[0].appendChild(filterDockExtensionView.$el.get(0));
				dom[0].appendChild(filterDockCollapseView.$el.get(0));
				this.props.dashboardApi.triggerDashboardEvent('filterDock:expand');
			}
		}
	}
}

FilterDock.propTypes = {
	dashboardApi: PropTypes.object.isRequired,
	filterDockModel: PropTypes.object
};

export default FilterDock;



// WEBPACK FOOTER //
// ./src/js/components/filterDock/FilterDock.js